export default "__VITE_ASSET__gJt4YJ3r__"